export default __webpack_public_path__ + "94b88af.png";